import { useMutation } from "@tanstack/react-query";
import { assignCoach, unassignCoach } from "@/services/edgeFunctionWrappers/coachAssignmentsWrapper";
import { useUserStore } from "@/store/userStore";

export const useAssignCoach = (coachId?: string | null) => {
  const gymId = useUserStore((state) => state.gymId);

  return useMutation({
    mutationFn: async (classBookingId: string) => {
      if (!coachId) throw new Error("Missing coachId");
      if (!gymId) throw new Error("Missing gymId");

      return await assignCoach({
        class_booking_id: classBookingId,
        coach_id: coachId,
        gym_id: gymId,
      });
    },
  });
};

export const useUnassignCoach = (coachId: string | undefined | null) => {
  const gymId = useUserStore((state) => state.gymId);

  return useMutation({
    mutationFn: async (classBookingId: string) => {
      if (!coachId) throw new Error("Missing coachId");
      if (!gymId) throw new Error("Missing gymId");

      return await unassignCoach({
        class_booking_id: classBookingId,
        coach_id: coachId,
        gym_id: gymId,
      });
    },
  });
};
